const link = process.env.REACT_APP_BACKEND_URL

export default link;